import { render, staticRenderFns } from "./BoardIcon.vue?vue&type=template&id=b9fbace0&scoped=true"
import script from "./BoardIcon.vue?vue&type=script&lang=js"
export * from "./BoardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fbace0",
  null
  
)

export default component.exports